// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FullScreenGridLayout__video-layout-caec04 {
  flex: 1 0;
  display: grid;
  gap: 8px;
  padding: 8px;
  box-sizing: border-box;
  height: 100%;
}

.FullScreenGridLayout__video-layout-1-eda2ba {
  grid-template-rows: 1fr;
}

.FullScreenGridLayout__video-layout-2-b31897 {
  grid-template-columns: 1fr 1fr;
}

.FullScreenGridLayout__video-layout-3-f69c8f {
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  grid-template-areas: ". last" ". last";
}

.FullScreenGridLayout__video-layout-3-f69c8f > div:last-child {
  grid-area: last;
}

.FullScreenGridLayout__video-layout-4-f3b7db {
  grid-template-rows: 1fr 1fr;
  grid-template-columns: 1fr 1fr;
}

.FullScreenGridLayout__video-layout-5-e95bf9 {
  grid-template-rows: 1fr 1fr;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-areas: ". . last" ". . last";
}

.FullScreenGridLayout__video-layout-5-e95bf9 > div:last-child {
  grid-area: last;
}

.FullScreenGridLayout__video-layout-6-a9d57e {
  grid-template-columns: 1fr 1fr 1fr;
  grid-auto-rows: minmax(46.5%, 1fr);
  overflow: auto;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/FullScreenCallView/Shared/FullScreenGridLayout/FullScreenGridLayout.styles.m.css"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,aAAA;EACA,QAAA;EACA,YAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,8BAAA;EACA,2BAAA;EACA,sCAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,2BAAA;EACA,8BAAA;AACF;;AAEA;EACE,2BAAA;EACA,kCAAA;EACA,0CAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,kCAAA;EACA,kCAAA;EACA,cAAA;AACF","sourcesContent":[".video-layout {\n  flex: 1 0;\n  display: grid;\n  gap: 8px;\n  padding: 8px;\n  box-sizing: border-box;\n  height: 100%;\n}\n\n.video-layout-1 {\n  grid-template-rows: 1fr;\n}\n\n.video-layout-2 {\n  grid-template-columns: 1fr 1fr;\n}\n\n.video-layout-3 {\n  grid-template-columns: 1fr 1fr;\n  grid-template-rows: 1fr 1fr;\n  grid-template-areas: '. last' '. last';\n}\n\n.video-layout-3 > div:last-child {\n  grid-area: last;\n}\n\n.video-layout-4 {\n  grid-template-rows: 1fr 1fr;\n  grid-template-columns: 1fr 1fr;\n}\n\n.video-layout-5 {\n  grid-template-rows: 1fr 1fr;\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-template-areas: '. . last' '. . last';\n}\n\n.video-layout-5 > div:last-child {\n  grid-area: last;\n}\n\n.video-layout-6 {\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-auto-rows: minmax(46.5%, 1fr);\n  overflow: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"video-layout": `FullScreenGridLayout__video-layout-caec04`,
	"videoLayout": `FullScreenGridLayout__video-layout-caec04`,
	"video-layout-1": `FullScreenGridLayout__video-layout-1-eda2ba`,
	"videoLayout1": `FullScreenGridLayout__video-layout-1-eda2ba`,
	"video-layout-2": `FullScreenGridLayout__video-layout-2-b31897`,
	"videoLayout2": `FullScreenGridLayout__video-layout-2-b31897`,
	"video-layout-3": `FullScreenGridLayout__video-layout-3-f69c8f`,
	"videoLayout3": `FullScreenGridLayout__video-layout-3-f69c8f`,
	"video-layout-4": `FullScreenGridLayout__video-layout-4-f3b7db`,
	"videoLayout4": `FullScreenGridLayout__video-layout-4-f3b7db`,
	"video-layout-5": `FullScreenGridLayout__video-layout-5-e95bf9`,
	"videoLayout5": `FullScreenGridLayout__video-layout-5-e95bf9`,
	"video-layout-6": `FullScreenGridLayout__video-layout-6-a9d57e`,
	"videoLayout6": `FullScreenGridLayout__video-layout-6-a9d57e`
};
module.exports = ___CSS_LOADER_EXPORT___;
